var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{staticClass:"position-fixed",attrs:{"dismissible":"","variant":_vm.msg.success ? 'success' : 'danger'},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" "+_vm._s(_vm.msg.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }